module.exports = __webpack_public_path__ + "static/media/logoIphone2.7350cf99.png";